import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { NgbAlert, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NivelControlCredito, UsuarioNivelControlCredito } from '@shared/models/controlCredito/NivelControlCredito';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HoraBloqueoClientes } from '@shared/models/controlCredito/HoraBloqueoClientes';
import { MessageService } from '@shell/message.service';
import { NivelesDetalleComponent } from './niveles-detalle/niveles-detalle.component';
import { NivelFormComponent } from './modales/nivel-form/nivel-form.component';
import { ModificarHoraBloqueoComponent } from './modales/modificar-hora-bloqueo/modificar-hora-bloqueo.component';
import { ModalUsuariosDelegacionesComponent } from './modales/modal-usuarios-delegaciones/modal-usuarios-delegaciones.component';

@Component({
  selector: 'app-niveles-aprobacion',
  standalone: true,
  imports: [CommonModule, NgbAlert, NgxSpinnerModule, NivelesDetalleComponent],
  templateUrl: './niveles-aprobacion.component.html',
  styleUrl: './niveles-aprobacion.component.scss'
})
export class NivelesAprobacionComponent implements OnInit {

  cargandoLista: boolean;
  niveles: NivelControlCredito[];
  nivelSeleccionado: NivelControlCredito;
  horaBloqueo: HoraBloqueoClientes;

  constructor(
    private controlCreditoService: ControlCreditoService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.cargarNiveles();
    this.obtenerHoraBloqueo();
  }

  cargarNiveles() {
    this.cargandoLista = true;
    this.spinner.show('spinnerGrafico');
    this.controlCreditoService.getNiveles().subscribe(
      n => {
        this.niveles = n;
        this.spinner.hide('spinnerGrafico');
        this.cargandoLista = false;
      },
      () => {
        this.spinner.hide('spinnerGrafico');
        this.cargandoLista = false;
        this.messageService.showErrorMessage('Hubo un error al cargar los niveles de aprobación.');
      }
    );
  }

  seleccionarNivel(index) {
    this.nivelSeleccionado = this.niveles[index];
  }

  nuevoNivel() {
    const modalRef = this.modalService.open(NivelFormComponent);
    modalRef.componentInstance.nuevoNivel = true;
    modalRef.result.then(nivel => {
      if (nivel) {
        this.messageService.showSuccessMessage('El nuevo nivel se ha creado exitosamente');
        this.cargarNiveles();
      }
    });
  }

  editarNivel() {
    const modalRef = this.modalService.open(NivelFormComponent);
    modalRef.componentInstance.nuevoNivel = false;
    modalRef.componentInstance.nivelSeleccionado = this.nivelSeleccionado;
    modalRef.result.then(nivel => {
      if (nivel) {
        this.nivelSeleccionado = nivel;
        this.actualizarArregloNiveles(nivel);
        this.messageService.showSuccessMessage('El nivel se ha editado exitosamente');
      }
    });
  }

  actualizarArregloNiveles(nivel) {
    const idNivel = this.niveles.findIndex(n => n.id === nivel.id);
    if (idNivel !== -1) {
      console.log(nivel)
      this.niveles[idNivel] = nivel; 
    }
  }


  obtenerHoraBloqueo() {
    this.controlCreditoService.obtenerHoraBloqueoClientes().subscribe(h => {
      this.horaBloqueo = h;
    });
  }

  cambiarHoraBloqueoCuentas() {
    const modalRef = this.modalService.open(ModificarHoraBloqueoComponent);
    modalRef.componentInstance.horaActualConfiguracion = this.horaBloqueo;
    modalRef.result.then(h => {
      if (h) {
        this.horaBloqueo = h;
        this.messageService.showSuccessMessage('La hora de bloqueo se ha configurado exitosamente.');
      }
    });
  }

  agregarUsuarios() {
    const modalRef = this.modalService.open(ModalUsuariosDelegacionesComponent);
    modalRef.componentInstance.esDelegacion = false;
    modalRef.componentInstance.nivelSeleccionado = this.nivelSeleccionado;

    modalRef.result.then((nivelActualizado: NivelControlCredito) => {
      if (!nivelActualizado) return;
      this.nivelSeleccionado = nivelActualizado;
      this.actualizarArregloNiveles(nivelActualizado);
      this.messageService.showSuccessMessage('Nivel actualizado correctamente.');
    });
  }
  
  agregarDelegaciones() {
    const modalRef = this.modalService.open(ModalUsuariosDelegacionesComponent);
    modalRef.componentInstance.esDelegacion = true;
    modalRef.componentInstance.nivelSeleccionado = this.nivelSeleccionado;

    modalRef.result.then((nivelActualizado: NivelControlCredito) => {
      if (!nivelActualizado) return;
      this.nivelSeleccionado = nivelActualizado;
      this.actualizarArregloNiveles(nivelActualizado);
      this.messageService.showSuccessMessage('Nivel actualizado correctamente.');
    });
  }

  actualizarUsuarios(usuarios: UsuarioNivelControlCredito[]) {
    this.nivelSeleccionado.usuarios = usuarios.filter(u => !u.fechaHasta);
    this.nivelSeleccionado.delegaciones = usuarios.filter(u => u.fechaHasta);
  }
}